import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';


const initialState = {
  isChecked: JSON.parse(localStorage.getItem('insuranceChecked')) !== null
    ? JSON.parse(localStorage.getItem('insuranceChecked'))
    : true,
};

const insuranceSlice = createSlice({
  name: 'insurance',
  initialState,
  reducers: {
    toggleCheckbox: (state) => {
      state.isChecked = !state.isChecked;
      localStorage.setItem('insuranceChecked', JSON.stringify(state.isChecked));
    },
    setCheckbox: (state, action) => {
      state.isChecked = action.payload;
      localStorage.setItem('insuranceChecked', JSON.stringify(state.isChecked));
    },
  },
});


export const { toggleCheckbox, setCheckbox } = insuranceSlice.actions;


export default insuranceSlice.reducer;


export const applyInsurance = async (customer_id, checked) => {
  const data = JSON.stringify({
    query: `mutation InsuranceApply($input: InsuranceApplyInput!) {
      InsuranceApply(input: $input) {
        status
        message
      }
    }`,
    variables: { "input": { "customer_id": customer_id, "insurance_checbox": checked } }
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/graphql', 
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
    data: data
  };

  try {
    const response = await axios.request(config);
    console.log(JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    toast.error(error.message);
    throw error;
  }
};
